import React, { Component } from 'react';
import { Input, PhoneNumber } from '../../../ui/Form/index';

export default class InputForm extends Component {
  render() {
    return (
      <form>
        <PhoneNumber className="phonenofield" />
        <button>CALL ME NOW</button>
      </form>
    );
  }
}
